import request from '../../js/lib/request';
import Debounce from '../../js/lib/debounce';
import currentLang from '../../js/lib/currentLang';

const modals = document.querySelectorAll('.limraModal');

const options = {
	headers: {
		'content-type': 'application/json; charset=utf-8'
	}
};

var AutofillComponent = {
	template: '#autofill-template',
	props: ['initialUrl'],
	data: function() {
		return {
			allValues: '',
			selected: '',
			input: '',
			dataUrl: '',
		};
	},
	watch: {
		// whenever input changes, this function will run
		input: function(newInput) {
			this.getPrompt();
		},
		dataUrl: function () {
			this.loadData();
		}
	},
	// When Component is Mounted, run Methods
	mounted: function() {
		const self = this;

		// no enter press allowed
		self.$refs.autofillInput.addEventListener('keypress', (event)=>{
			if (event.type === 'keypress' && event.keyCode === 13) {
				event.preventDefault();
			}
		}, false);

		self.input = '';
		self.dataUrl = self.initialUrl;

		// list always open
		self.$refs.autofillPanel.setAttribute('open', true);

		self.loadData();
	},
	// Methods
	methods: {

		loadData: function () {
			const self = this;
			ModalWin.$emit('isLoading'); // hail parent component

			if (self.dataUrl != '') {
				// get all values
				request().get(self.dataUrl + '?lang=' + currentLang()).then(function (response) {
					// filter list; first value will always be the one to filter if possible
					const filterList = ['n/a', 'na', '', 'notavailable'];
					if (response && response.length > 0) {
						for (var x = 0; x < filterList.length; x++) {
							if (response[0].value.toLowerCase() == filterList[x])
								response.splice(0, 1);
						}
					}

					self.allValues = response; // set all values until user starts typing
					self.selected = response; // set all values until user starts typing
					ModalWin.$emit('doneLoading'); // hail parent component
				});
			}
		},
		// Load Primary Menu
		getPrompt: Debounce(function() {
			var self = this;

			if (self.input.length < 2) 	
				self.selected = self.allValues;
			else
			{
				self.selected = [];

				var findMatch = new RegExp(self.input,'gi');
				for (var x = 0; x < self.allValues.length; x++) 
				{
					if(self.allValues[x].text.match(findMatch))
						self.selected.push(self.allValues[x]);
				}
			}

		}, 500),
		selectItem: function(val, text) {
			const self = this;
			ModalWin.$emit('autofillChosen', val, text, self.dataUrl); // hail parent component
		},
	}
};

var RegionPickerComponent = {
	template: '#region-picker-template',
	props: ['originaldata'],
	data: function() {
		return {
			regionChosen: '',
		};
	},
	components: {
		'autofill-component': AutofillComponent,
	},
	mounted: function () {
		ModalWin.$emit('doneLoading'); // hail parent component
	},
	methods: {
		closeModal: function() {
			ModalWin.$emit('closeModal');
		}
	}
};

var GeneralComponent = {
	template: '#general-template',
	props: ['originaldata'],
	data: function() {
		return {
			showFooter: false,
			formData: '',
			isLoading: false,
		};
	},
	components: {
		'autofill-component': AutofillComponent,
	},
	mounted: function() {
		const self = this;

		self.formData = self.originaldata;

		// if we have some buttons, show them!
		if(self.formData.buttonOk.length > 0 || self.formData.buttonCancel.length > 0)
			self.showFooter = true; 
		else
			self.showFooter = false;

	},
	methods: {
		validateForm: function() {
			const self = this;

			var errorList = [];
			var txtMultiList = [];

			// these seem to get lost somehow.. we need to store them to make them persist in the obj list
			if(self.$refs['txtMultiItem'] != null)
			{
				for (var z = 0; z < self.$refs['txtMultiItem'].length; z++) 
					txtMultiList.push(self.$refs['txtMultiItem'][z].value);
			}

			for (var x = 0; x < self.formData.thisForm.items.length; x++) 
			{
				var thisItem = self.formData.thisForm.items[x];
				thisItem.isValid = true; // assume true until we go down the path below

				if(thisItem.type != 'autofill') // don't check autofills; no validation necessary
				{
					var itemType = thisItem.type + 'Item';
					for (var y = 0; y < self.$refs[itemType].length; y++) 
					{
						var clientItem = self.$refs[itemType][y];
						if(clientItem.name == thisItem.name) // check names to make sure we got the right one
						{
							if (itemType == "ConsentToContactChkItem") {
								if (clientItem.checked) {
									clientItem.value = "1";
								}
							}

							// always set value
							thisItem.value = clientItem.value;

							// required field
							if (thisItem.isRequired && clientItem.value.length <= 0)
								errorList.push('- ' + thisItem.displayName + ' is a required field.\r\n');

							// additional regex
							if (thisItem.additionalConstraints != null) {
								var checkValid = new RegExp(thisItem.additionalConstraints, 'g');
								if (!clientItem.value.match(checkValid))
									errorList.push('- ' + thisItem.displayName + ' needs to be a valid entry.\r\n');
							}

						}
					}
				}
			}

			if(errorList.length > 0)
			{
				var finalError = '';
				for (x = 0; x < errorList.length; x++) 
					finalError += errorList[x];

				alert (finalError);
			}
			else
				ModalWin.$emit('submitForm', self.formData.thisForm.items); // hail parent component

		},
		closeModal: function() {
			ModalWin.$emit('closeModal'); // hail parent component
		},
		cancelForm: function() {
			ModalWin.$emit('isLoading'); // hail parent component

			if(this.formData.buttonCancelLink && this.formData.buttonCancelLink.length > 0)
				window.location.href = this.formData.buttonCancelLink;
			else
				ModalWin.$emit('closeModal'); // hail parent component
		},
	}
};

// popup; tied to a single popup that changes content and behavior based on the trigger
const ModalWin = new Vue({
	el: '#LimraModal',
	data: {
		showModal: false,
		modalLoading: false,
		modalHref: '',
		formData: '',
	},
	mounted: function() {
		const self = this;
		
		// set event handler to listen for triggers, calls from children components, etc
		// Methods for opening/closing modal
		self.$on('runModal', (modalHref) => {
			self.modalHref = modalHref;
			self.modalLoading = true;
			self.showModal = true;
			self.previouslyFocusedElement = document.activeElement;
			
			document.addEventListener('keydown', (e) => {
				if (self.showModal && e.code == 'Escape') {
					self.close();
				}
			});

			request().get(modalHref + '?lang=' + currentLang()).then(function(response) {
				self.formData = response;
				self.modalLoading = false;
			});
		});

		self.$on('isLoading', () => {
			self.modalLoading = true;
		});

		self.$on('doneLoading', () => {
			self.modalLoading = false;
			document.getElementById('modalContent').focus();
		});

		self.$on('closeModal', () => {
			this.close();
		});

		// method to accept a chosen value from an autocomplete.  saves the choice to the parent data object
		self.$on('autofillChosen', (val, text, dataUrl) => {

			// special case for countries; need to submit to controller
			if(dataUrl == '/country')
				request().post('/RegionPicker/SubmitCountry/' + val).then(function(regionChanged) {
					self.finalizeRegion(regionChanged, text);
				});
			else
			{
				// set the value in our data
				for (var x = 0; x < self.formData.thisForm.items.length; x++) 
				{
					var thisItem = self.formData.thisForm.items[x];

					if(thisItem.dataUrl == dataUrl)
					{
						thisItem.value = val;
						thisItem.text = text;
					}
				}

				// if only one item, just submit..
				if(self.formData.thisForm.items.length == 1)
					self.$emit('submitForm', self.formData.thisForm.items); // hail parent component
			}
		});

		// method to submit the form back to a server
		self.$on('submitForm', (clientForm) => {
			self.formData.thisForm.items = clientForm;

			if(!self.formData.actionInternal) // external link, post html form to third party
				self.$refs['modalForm'].submit();
			else
			{
				// post
				request(options).post(self.formData.action, JSON.stringify(self.formData)).then(function(response) {

					if(response != null && response.formModifiers != null)
					{
						// loop through our success object to make any modifications to underlying forms..
						for (var x = 0; x < response.formModifiers.length; x++) 
						{
							const formVal = document.getElementById(response.formModifiers[x].key);
							if(formVal != null)
								formVal.value = response.formModifiers[x].value;
						}
					}

					// and, close modal
					self.close();
				});

			}
		});
	},
	components: {
		'general-component': GeneralComponent,
		'region-picker-component': RegionPickerComponent,
	},
	methods:  {         
		finalizeRegion: function (regionChanged, regionText) {
			if (regionText.startsWith('Canada (Fr'))
				window.location.href = '/fr';			
            else if (regionChanged)
                window.location.reload();
			else
				this.showModal = false;
		},
		close: function () {
			if(this.formData.isClosable)
			{
				this.previouslyFocusedElement.focus();
				this.showModal = false;
			}
		},
	}
});

if(modals.length > 0)
{
	for(var x=0; x<modals.length; x++)
	{
		const id = modals[x].id;

		// trigger event; attached to the element that runs the modal
		const triggerModal = new Vue({
			el: '#' + id,
			mounted: function() {
				const self = this;

				// fill data sets
				const trigger = self.$el.getAttribute('data-trigger');

				// initialize element
				if(trigger == 'click') // run on user click
				{
					self.$el.addEventListener('click', ($event) => {
						self.clickModal($event);
					});
				}
				if(trigger == 'auto') // run now
					self.runModal(true);
			},
			methods: {
				clickModal: function(e) {
					const self = this;

					e.preventDefault();
					self.runModal(false);
				},
				runModal: function() {
					const self = this;

					// emit to our modal with all the data from the link
					ModalWin.$emit('runModal',
						self.$el.getAttribute('data-modalHref'));
				},
			}
		});
	}
}


// WEBPACK FOOTER //
// ../components/modal/modal.js